var params = window.location.search.substr(1).split('&');

if (params != '') {
  for (var i = 0; i < params.length; i++) {
    var p = params[i].split('=');
    if (p[0] == 'ref') {
      localStorage.setItem('siteref', decodeURIComponent(p[1]));
    }
  }
}

var siteUrl = window.location.href;
if (siteUrl.includes("ref=") || siteUrl.includes("utm_")) {
  localStorage.setItem('referrer_url', siteUrl);
}

function isMobileDevice() {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}

function goToHREFLink(buttonId, linkParam, urlParam) {
  var mLink = isMobileDevice() ? "-m" : "";
  var myLink = linkParam + mLink + (urlParam ? "?" + urlParam : "");
  document.getElementById(buttonId).setAttribute('href', myLink);
  return false;
}

function goToHREFLinkAP_ORIG_06112025(buttonId, linkParam, urlParam) {
  var quoteBases = [linkParam, '/pages/new-a-get-a-quick-quote-its-free'];

  var currentIndex = parseInt(localStorage.getItem('quote-cycle-index') || '0');
  var selectedLink = quoteBases[currentIndex];

  var nextIndex = (currentIndex + 1) % quoteBases.length;
  localStorage.setItem('quote-cycle-index', nextIndex);

  var mLink = isMobileDevice() ? "-m" : "";

  if (isMobileDevice()) {
    selectedLink = linkParam;
  }

  var myLink = selectedLink + mLink + (urlParam ? "?" + urlParam : "");
  document.getElementById(buttonId).setAttribute('href', myLink);
  return false;
}

function goToHREFLinkAP_Rotate(buttonId, linkParam, urlParam) {
  var random = Math.floor(Math.random() * 2);

  var selectedLink = random === 0
    ? linkParam
    : '/pages/new-a-get-a-quick-quote-its-free';

  if (isMobileDevice()) {
    selectedLink = linkParam;
  }

  var mLink = isMobileDevice() ? "-m" : "";
  var myLink = selectedLink + mLink + (urlParam ? "?" + urlParam : "");

  document.getElementById(buttonId).setAttribute('href', myLink);
  return false;
}

function goToHREFLinkAP_Rotate_AddLogo(buttonId, linkParam, urlParam) {
  var random = Math.floor(Math.random() * 2);

  var selectedLink = random === 0
    ? linkParam
    : '/pages/new-add-your-logo-design';

  if (isMobileDevice()) {
    selectedLink = linkParam;
  }

  var mLink = isMobileDevice() ? "-m" : "";
  var myLink = selectedLink + mLink + (urlParam ? "?" + urlParam : "");

  document.getElementById(buttonId).setAttribute('href', myLink);
  return false;
}

function goToHREFLinkAP_Rotate_Sample(buttonId, linkParam, urlParam) {
  var random = Math.floor(Math.random() * 2);

  var selectedLink = random === 0
    ? linkParam
    : '/pages/new-getting-a-free-sample';

  if (isMobileDevice()) {
    selectedLink = linkParam;
  }

  var mLink = isMobileDevice() ? "-m" : "";
  var myLink = selectedLink + mLink + (urlParam ? "?" + urlParam : "");

  document.getElementById(buttonId).setAttribute('href', myLink);
  return false;
}

function goToHREFLinkAP(buttonId, linkParam, urlParam) {
  var mLink = isMobileDevice() ? "-m" : "";
  var myLink = linkParam + mLink + (urlParam ? "?" + urlParam : "");
  document.getElementById(buttonId).setAttribute('href', myLink);
  return false;
}